import { VERIFY_CONTEST_ERROR, VERIFY_CONTEST_REQUEST, VERIFY_CONTEST_FINISH, VERIFY_CONTEST_SUCCESS } from "../Const/const"


const verifyContestReducer = (state = { isValidContest: false, contestId: null }, action) => {
    switch (action.type){
        case VERIFY_CONTEST_REQUEST:
            return state
        case VERIFY_CONTEST_SUCCESS:
            return action.payload
        case VERIFY_CONTEST_ERROR:
            return state
        case VERIFY_CONTEST_FINISH:
            return { isValidContest: false, contestId: null }
        default: 
            return state
    }
}

export default verifyContestReducer